import React from "react";

const Page404 = (props: any) => <React.Fragment>Page404</React.Fragment>;

export default Page404;
